import React from "react";
import { FaArrowRight } from "react-icons/fa";
import "./manet_life.css";
import { Link } from "react-router-dom";

const ManetLife = () => {
  const cards = [
    {
      buttons: [
        { text: "Conduct at campus", link: "/lifeatcampus/conduct-at-campus" },
        { text: "Accomodation", link: "/lifeatcampus/accommodation" },
        { text: "Library", link: "/lifeatcampus/library" },
      ],
    },
    {
      buttons: [
        { text: "Sports", link: "/lifeatcampus/sports" },
        { text: "National Maritime Day", link: "/lifeatcampus/national-maritime-day" },
        { text: "Vishwanath Sports Meet", link: "/lifeatcampus/vishwanath-sport" },
      ],
    },
    {
      buttons: [
        { text: "MIT-Persona Fest", link: "/lifeatcampus/mit-persona-fest" },
        { text: "Student Grievance", link: "/lifeatcampus/student-grievance" },
        { text: "FAQ", link: "/admissions/admission-faq" },
      ],
    },
  ];

  return (
    <section className="manetlife">
      <div className="manetlife-container">
        <h1 className="title" id="manetlife-title">
          Life @ MANET
        </h1>
        <h2 className="subtitle" id="manetlife-subtitle">
          Experience the culture, opportunities, and inspiration that make MANET
          unique.
        </h2>

        <div className="manetlife-cards">
          <div className="manetlife-cards-grid">
            {cards.map((card, idx) => (
              <div key={idx} className="manetlife-card">
                <div className="manetlife-btn-grid">
                  {card.buttons.map((btn, i) => (
                    <Link to={btn.link} key={i}>
                      <button className="manetlife-card-btn">
                        <FaArrowRight className="manetlife-icon" />
                        {btn.text}
                      </button>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManetLife;
